module.exports = __webpack_public_path__ + "static/img/arrow_down_w.ba614c19.svg";